/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ApiKey } from './ApiKey.js';
import {
    ApiKeyFromJSON,
    ApiKeyFromJSONTyped,
    ApiKeyToJSON,
} from './ApiKey.js';

/**
 * 
 * @export
 * @interface RevokeApiKeyResponse
 */
export interface RevokeApiKeyResponse {
    /**
     * 
     * @type {ApiKey}
     * @memberof RevokeApiKeyResponse
     */
    data?: ApiKey;
    /**
     * 
     * @type {number}
     * @memberof RevokeApiKeyResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof RevokeApiKeyResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof RevokeApiKeyResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof RevokeApiKeyResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the RevokeApiKeyResponse interface.
 */
export function instanceOfRevokeApiKeyResponse(value: object): boolean {
    return true;
}

export function RevokeApiKeyResponseFromJSON(json: any): RevokeApiKeyResponse {
    return RevokeApiKeyResponseFromJSONTyped(json, false);
}

export function RevokeApiKeyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevokeApiKeyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ApiKeyFromJSON(json['data']),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function RevokeApiKeyResponseToJSON(value?: RevokeApiKeyResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': ApiKeyToJSON(value['data']),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

